// <template>
// 	<div>
// 		<el-drawer :visible.sync="drawer_model" :size="drawer_size" :title="drawer_title" :width="drawer_width" @opened="drawer_onshow" @closed="drawer_onhide" destroy-on-close>

// 		</el-drawer>
// 	</div>
// </template>
// <style scoped>

// </style>

export default {
	props: {

	},
	data() {
		return {
			drawer_model: false,
			drawer_loading: false,
			drawer_title: '弹窗',
			drawer_size: '60%',
		}
	},
	created() {

	},
	methods: {
		drawer_init() {
			
		},
		drawer_cancel() {
			this.drawer_model = false
		},
		drawer_onhide() {
			this.$emit('drawerhide')
		},
		drawer_onshow() {
			this.drawer_init()
		},
		drawer_show() {
			this.drawer_model = true
		},
	},
}